import useSWR from 'swr'

import { useAuthToken } from '@/hooks/useAuthToken'
import { type AuthContextResponse, meService } from '@/services/meService'

export function useAuthContext() {
  const { getToken, isSignedIn } = useAuthToken()

  const fetcher = async (url: string) => {
    const token = await getToken()
    if (!token) throw new Error('Authentication token not available')

    const response = await fetch(url, {
      method: 'GET',
      headers: { Authorization: `Bearer ${token}` },
    })

    if (!response.ok) {
      throw new Error('Failed to fetch auth context')
    }

    return response.json()
  }

  return useSWR<AuthContextResponse>(isSignedIn ? meService.authContextUrl() : null, fetcher, {
    revalidateOnFocus: false,
    dedupingInterval: 60_000,
  })
}
